'use client';

import { CenteredPageLayout } from '@/layout/CenteredPageLayout';
import { DiscussYourPropertyForm } from './DiscussYourPropertyForm';
import { HeroBanner } from './HeroBanner';

const SellPage = () => {
  return (
    <CenteredPageLayout>
      <div className="space-y-8">
        <HeroBanner />
        <DiscussYourPropertyForm />
      </div>
    </CenteredPageLayout>
  );
};

export default SellPage;
